import * as Yup from 'yup';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { addResume, udpateResume } from './ResumeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import LoadingSpinner from '../../../component/resuable/LoadingSpinner';
import ResumeForm from './ResumeForm';
import JapaneseResumeForm from './JapaneseResumeForm';
import { getJPResumeById } from '../management/ManagementSlice';


export default function ResumeData({ handleBack, editData: engliahEditData, }) {
    const dispatch = useDispatch();
    const [newChip, setNewChip] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);
    const [activeTab, setActiveTab] = useState('EN')
    const [initialValues, setInitialValues] = useState({
        name: '',
        email: '',
        phone: '',
        skill: [],
        // current_salary: '',
        // expected_salary: '',
        // status: '',
        sex: '',
        // notice_period: '',
        // location: '',
        // mode: '',
        file: '',
        id: '',
        years_of_exp: '',
        language: '',

        passport_copy: '',
        resident_copy: '',
        air_ticket: '',
        coe: '',
        visa: '',
        option_file: '',
        remarks: '',
        employement_contract: '',
        emergency_contact: '',
        // contact_details :'',
        employeer_name: '',
        arrival_date: null,

        //new fields
        admission_number: "",
        ad_fees: "",
        date_of_admission: new Date(),
        dob: null,
        passport_no: '',
        height: '',
        weight: '',
        marital_status: "",
        nationality: "",
        religion: "",
        communication: "",
        reference: "",
        educational_qualification: "",
        additional_qualification: "",
        english_knowledge: "",
        profile_pic: "",
        sign: "",
        educationalCertificate: '',
        medicalReport: '',
        vaccinationCertificate: '',

        age: "",
        place_of_birth: "",
        reason_for_apply: '',
        cooperative_living: '',
        favorite_subject: "",
        licenses_and_qualifications: "",
        tattoo: "",
        blood_type: "",
        right_vision: "",
        left_vision: "",
        color_blindness: "",
        blood_pressure: "",
        dominant_hand: "",
        foods_cannot_eat: [],
        smoking: "",
        drinking_beer: "",
        hobbies: [],
        strengths: [],
        weaknesses: [],
        medical_history: "",
        spouse: "",
        personal_income: "",
        family_income: "",
        relatives_in_japan: "",
        japanese_address: "",
        experience_coming_to_japan: "",
        desired_years_to_work_in_japan: "",
        savings_per_year: "",
        plans_or_goals_after_returning: "",
        version: "",
        academic_details: [],
        family_details: [],
        work_experience_list: [],
        english_pdf: ""


    });
    const jpResumeData = useSelector((state) => state.management.jpResumeData);
    const editData = activeTab === "EN" ? engliahEditData : jpResumeData?.candidates?.[0]; // Assuming you have a separate state for Japanese data
    // email: Yup.string().required("Email is required"),
    // phone: Yup.string().required("Phone Number is required"),
    // skill: Yup.array().min(1, "At least one Skill is required"),
    // current_salary: Yup.string().required("Current Salary is required"),
    // expected_salary: Yup.string().required("Expected Salary is required"),
    // status: Yup.string().required("Status is required"),
    // location: Yup.string().required("Location is required"),
    // mode: Yup.string().required("Preferred is required"),
    // years_of_exp: Yup.string().required("Experience is required"),
    const validationSchema = Yup.object().shape({
        name: Yup.string().required("User Name is required"),
        sex: Yup.string().required("Sex is required"),
        file: Yup.string().required("File is required"),
        language: Yup.string().required("language is required"),
        employeer_name: Yup.string().required("Employeer Name is required"),
    });
    const validationSchemaJp = Yup.object().shape({
        name: Yup.string().required("ユーザー名は必須です"),
        sex: Yup.string().required("性別は必須です"),
        language: Yup.string().required("言語は必須です"),
        employeer_name: Yup.string().required("雇用者名は必須です"),
        
    });

    function formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${year}-${month}-${day}`;
    }

    const appendFileField = (formData, fieldName, value) => {
        if (value instanceof Blob || value instanceof File) {
            formData.append(fieldName, value);
        } else {
            formData.append(fieldName, '');
        }
    };

    let role = Cookies.get("role");
    const handleSubmit = async (values) => {

        // setIsLoading(true);
        const formattedArrivalDate = values.arrival_date ? dayjs(values.arrival_date).format('YYYY-MM-DD') : "";
        const formattedDob = values.dob ? dayjs(values.dob).format('YYYY-MM-DD') : "";
        const formattedDate_of_admission = values.date_of_admission ? dayjs(values.date_of_admission).format('YYYY-MM-DD') : "";
        // const formattedArrivalDate = values.arrival_date  ? formatDate(values.arrival_date ) : '';
        setIsLoading(true);
        // console.log(values);

        let formData = new FormData();
        // formData.append("mode", values.mode)
        formData.append('employeer_name', values.employeer_name);
        formData.append('name', values.name);
        formData.append('email', values.email);
        formData.append('phone', values.phone);
        formData.append('skill', values.skill.join(','));
        // formData.append('current_salary', values.current_salary);
        // formData.append('expected_salary', values.expected_salary);
        // formData.append('status', values.status);
        // formData.append('notice_period', values.notice_period);
        formData.append('sex', values.sex);
        // formData.append('location', values.location);
        // formData.append('mode', values.mode);
        // formData.append('file', values.file);
        formData.append('years_of_exp', values.years_of_exp);
        formData.append('language', values.language);

        // formData.append('passport_copy', values.passport_copy);
        // formData.append('resident_copy', values.resident_copy);
        // formData.append('air_ticket', values.air_ticket);
        // formData.append('coe', values.coe);
        // formData.append('visa', values.visa);
        // formData.append('option_file', values.option_file);
        formData.append('remarks', values.remarks);
        formData.append('employement_contract', values.employement_contract ? values.employement_contract.includes('http') ? '' : values.employement_contract : '');
        formData.append('emergency_contact', values.emergency_contact);
        // formData.append('contact_details', values.contact_details);
        formData.append('employeer_name', values.employeer_name);
        formData.append('arrival_date', formattedArrivalDate)

        //new fields
        formData.append('admission_number', values.admission_number);
        formData.append('ad_fees', values.ad_fees);
        formData.append('date_of_admission', '');
        // formData.append('date_of_admission', formattedDate_of_admission);
        formData.append('dob', formattedDob)
        formData.append('passport_no', values.passport_no);
        formData.append('height', values.height);
        formData.append('weight', values.weight);
        formData.append('marital_status', values.marital_status);
        formData.append('nationality', values.nationality);
        formData.append('religion', values.religion);
        formData.append('communication', values.communication);
        formData.append('reference', values.reference);
        formData.append('educational_qualification', values.educational_qualification);
        formData.append('additional_qualification', values.additional_qualification);
        formData.append('english_knowledge', values.english_knowledge);
        // formData.append('profile_pic', values.profile_pic);
        appendFileField(formData, 'profile_pic', typeof values.profile_pic  == "string" && values.profile_pic.includes('http') ? '' : values.profile_pic);
        appendFileField(formData, 'sign', typeof values.sign === 'string' && values.sign.includes('http') ? '' : values.sign);
        appendFileField(formData, 'file', typeof values.file === 'string' && values.file.includes('http') ? '' : values.file);
        appendFileField(formData, 'passport_copy', typeof values.passport_copy === 'string' && values.passport_copy.includes('http') ? '' : values.passport_copy);
        appendFileField(formData, 'resident_copy', typeof values.resident_copy === 'string' && values.resident_copy.includes('http') ? '' : values.resident_copy);
        appendFileField(formData, 'air_ticket', typeof values.air_ticket === 'string' && values.air_ticket.includes('http') ? '' : values.air_ticket);
        appendFileField(formData, 'coe', typeof values.coe === 'string' && values.coe.includes('http') ? '' : values.coe);
        appendFileField(formData, 'option_file', typeof values.option_file === 'string' && values.option_file.includes('http') ? '' : values.option_file);
        appendFileField(formData, 'visa', typeof values.visa === 'string' && values.visa.includes('http') ? '' : values.visa);
        appendFileField(formData, 'educationalCertificate', typeof values.educationalCertificate === 'string' && values.educationalCertificate.includes('http') ? '' : values.educationalCertificate);
        appendFileField(formData, 'medicalReport', typeof values.medicalReport === 'string' && values.medicalReport.includes('http') ? '' : values.medicalReport);
        appendFileField(formData, 'vaccinationCertificate', typeof values.vaccinationCertificate === 'string' && values.vaccinationCertificate.includes('http') ? '' : values.vaccinationCertificate);

        // formData.append('educationalCertificate', values.educationalCertificate);
        // formData.append('medicalReport', values.medicalReport);
        // formData.append('vaccinationCertificate', values.vaccinationCertificate);

        formData.append('age', values.age);
        formData.append('place_of_birth', values.place_of_birth);
        formData.append('reason_for_apply', values.reason_for_apply);
        formData.append('cooperative_living', values.cooperative_living);
        formData.append('favorite_subject', values.favorite_subject);
        formData.append('licenses_and_qualifications', values.licenses_and_qualifications);
        formData.append('tattoo', values.tattoo);
        formData.append('blood_type', values.blood_type);
        formData.append('right_vision', values.right_vision);
        formData.append('left_vision', values.left_vision);
        formData.append('color_blindness', values.color_blindness);
        formData.append('blood_pressure', values.blood_pressure);
        formData.append('dominant_hand', values.dominant_hand);
        formData.append('foods_cannot_eat', values.foods_cannot_eat.join(','));
        formData.append('smoking', values.smoking);
        formData.append('drinking_beer', values.drinking_beer);
        formData.append('hobbies', values.hobbies.join(','));
        formData.append('strengths', values.strengths.join(','));
        formData.append('weaknesses', values.weaknesses.join(','));
        formData.append('medical_history', values.medical_history);
        formData.append('spouse', values.spouse);
        formData.append('personal_income', values.personal_income);
        formData.append('family_income', values.family_income);
        formData.append('relatives_in_japan', values.relatives_in_japan);
        formData.append('japanese_address', values.japanese_address);
        formData.append('experience_coming_to_japan', values.experience_coming_to_japan);
        formData.append('desired_years_to_work_in_japan', values.desired_years_to_work_in_japan);
        formData.append('savings_per_year', values.savings_per_year);
        formData.append('plans_or_goals_after_returning', values.plans_or_goals_after_returning);
        formData.append('version', activeTab === "EN" ? "EN" : 'JP')
        formData.append('academic_details', JSON.stringify(values.academic_details));
        formData.append('family_details', JSON.stringify(values.family_details));
        formData.append('work_experience_list', JSON.stringify(values.work_experience_list));



        if (editData) {

            formData.append('id', values.id);
            formData.append('japanese_file', typeof values.japanese_file === 'string' && values.japanese_file.includes('http') ? '' : values.japanese_file);
            // console.log("before posting update")
            // const response = await dispatch(udpateResume({ id: editData.id, formData })).unwrap();
            await dispatch(udpateResume({ id: editData.id, formData })).unwrap().then((response) => {
                if (response.status === 200) {
                    console.log("response updated data", response)

                    handleBack();
                    toast.success('Candidate Resume Updated Successfully');
                } else {
                    console.log("response error message data", response)

                    toast.error(response.payload.data.message)
                }
            }).catch(e => {
                console.log("Unexpected error occurred in update resume:", e)
            }).finally(() => {
                setIsLoading(false);
            });
            // console.log("after walkthrough update code")

            // if (response.status === 200) {
            //     console.log("response updated data", response)

            //     handleBack();
            //     toast.success('Candidate Resume Updated Successfully');
            // } else {
            //     toast.error()
            // }


        } else {


            formData.append('japanese_file', role === 'intermediate' || role === 'admin' ? values.japanese_file : "")
            console.log("before posting add", formData)

            // const response = await dispatch(addResume(formData));
            await dispatch(addResume(formData)).then((response) => {
                console.log(response)
                if (response.payload.status === 201) {
                    console.log("response posted data", response)
                    handleBack();
                    toast.success('Candidate Resume Added Successfully');
                } else {
                    console.log("response error message data", response)

                    toast.error(response.payload.data.message)
                }
            }).catch(e => {
                console.log("Unexpected error occurred in resume add:", e)
            }).finally(() => {
                setIsLoading(false);
            });
            console.log("after walkthrough update code")

            // if (response.payload.status === 201) {
            //     console.log("response posted data", response)
            //     handleBack();
            //     toast.success('User data added Successfully');
            // } else {
            //     toast.error(response.payload.data.message)
            // }
        }
    };

    const handleTabClick = (value) => {
        if (!editData?.id){
            setActiveTab(value);
            return;
        }
        if (value == "JP") {
            setIsLoading(true);
            dispatch(getJPResumeById(editData.id)).then((response) => {
                console.log("from resume JP DATA", response)
                if (response.type.includes('fulfilled')) {
                    setActiveTab(value)
                }
            }).finally(() => setIsLoading(false));
            return;
        }
        setActiveTab(value)
    }


    useEffect(() => {
        if (editData) {
            console.log("from resume DATA", editData)
            setInitialValues({
                ...editData,
                id: editData.id || '',
                employeer_name: editData.employeer_name || '',
                name: editData.name || '',
                email: editData.email || '',
                phone: editData.phone || '',
                skill: editData.skill ? editData.skill.split(',') : [],
                // current_salary: editData.current_salary || '',
                // expected_salary: editData.expected_salary || '',
                // status: editData.status || '',
                sex: editData.sex || '',
                // notice_period: editData.notice_period || '',
                // location: editData.location || '',
                // mode: editData.mode || '',
                file: editData.file_download || '',
                years_of_exp: editData.years_of_exp || '',
                language: editData.language || '',
                japanese_file: editData.japanese_file_path || '',

                arrival_date: editData.arrival_date || '',
                // contact_details: editData.contact_details || '',
                emergency_contact: editData.emergency_contact || '',
                coe: editData.coe || '',
                employement_contract: editData.employement_contract || '',
                air_ticket: editData.air_ticket || '',
                passport_copy: editData.passport_copy || '',
                resident_copy: editData.resident_copy || '',
                visa: editData.visa || '',
                remarks: editData.remarks || '',
                option_file: editData.option_file || '',
                employeer_name: editData.employeer_name || '',

                //new fields
                admission_number: editData.admission_number || '',
                ad_fees: editData.ad_fees || '',
                date_of_admission: editData.date_of_admission || '',
                dob: editData.dob ? new Date(editData.dob) : null,
                passport_no: editData.passport_no || '',
                height: editData.height || '',
                weight: editData.weight || '',
                marital_status: editData.marital_status || '',
                nationality: editData.nationality || '',
                religion: editData.religion || '',
                communication: editData.communication || '',
                reference: editData.reference || '',
                educational_qualification: editData.educational_qualification || '',
                additional_qualification: editData.additional_qualification || '',
                english_knowledge: editData.english_knowledge || '',
                profile_pic: editData.profile_pic || '',
                sign: editData.sign || '',
                educationalCertificate: editData.educationalCertificate || '',
                medicalReport: editData.medicalReport || '',
                vaccinationCertificate: editData.vaccinationCertificate || '',

                age: editData.age || '',
                place_of_birth: editData.place_of_birth || '',
                reason_for_apply: editData.reason_for_apply || '',
                cooperative_living: editData.cooperative_living || '',
                favorite_subject: editData.favorite_subject || '',
                licenses_and_qualifications: editData.licenses_and_qualifications || '',
                tattoo: editData.tattoo || '',
                blood_type: editData.blood_type || '',
                right_vision: editData.right_vision || '',
                left_vision: editData.left_vision || '',
                color_blindness: editData.color_blindness || '',
                blood_pressure: editData.blood_pressure || '',
                dominant_hand: editData.dominant_hand || '',
                foods_cannot_eat: typeof editData.foods_cannot_eat === 'string'
                    ? editData.foods_cannot_eat.split(',').map(h => h.trim()).filter(Boolean)
                    : Array.isArray(editData.foods_cannot_eat)
                        ? editData.foods_cannot_eat.map(h => String(h).trim()).filter(Boolean)
                        : [],
                smoking: editData.smoking || '',
                drinking_beer: editData.drinking_beer || '',
                hobbies: typeof editData.hobbies === 'string'
                    ? editData.hobbies.split(',').map(h => h.trim()).filter(Boolean)
                    : Array.isArray(editData.hobbies)
                        ? editData.hobbies.map(h => String(h).trim()).filter(Boolean)
                        : [],
                strengths: typeof editData.strengths === 'string'
                    ? editData.strengths.split(',').map(h => h.trim()).filter(Boolean)
                    : Array.isArray(editData.strengths)
                        ? editData.strengths.map(h => String(h).trim()).filter(Boolean)
                        : [],
                weaknesses: typeof editData.weaknesses === 'string'
                    ? editData.weaknesses.split(',').map(h => h.trim()).filter(Boolean)
                    : Array.isArray(editData.weaknesses)
                        ? editData.weaknesses.map(h => String(h).trim()).filter(Boolean)
                        : [],
                medical_history: editData.medical_history || '',
                spouse: editData.spouse || '',
                personal_income: editData.personal_income || '',
                family_income: editData.family_income || '',
                relatives_in_japan: editData.relatives_in_japan || '',
                japanese_address: editData.japanese_address || '',
                experience_coming_to_japan: editData.experience_coming_to_japan || '',
                desired_years_to_work_in_japan: editData.desired_years_to_work_in_japan || '',
                savings_per_year: editData.savings_per_year || '',
                plans_or_goals_after_returning: editData.plans_or_goals_after_returning || '',
                version: editData.version || '',
                academic_details: editData.academic_details || '',
                family_details: editData.family_details || '',
                work_experience_list: editData.work_experience_list || '',
                english_pdf: editData.english_pdf || '',
                japanese_pdf: editData.japanese_pdf || ''
            });
        }
    }, [editData]);

    return (
        <>
            {
                isLoading && <LoadingSpinner />
            }
            <div className="col-md-12">

                <div className="card p-3">
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className={`nav-link custom-link ${activeTab === "EN" ? "active" : ""}`} id="pills-english-tab" data-bs-toggle="pill" data-bs-target="#pills-english" type="button" role="tab" aria-controls="pills-english" aria-selected="true" onClick={() => handleTabClick("EN")}>English</button>
                        </li>
                        {role == "hr" || role === "managerment" ? null :
                            <li className="nav-item" role="presentation" hidden={!editData?.id}>
                                <button className={`nav-link custom-link  ${activeTab === "JP" ? "active" : ""}`} id="pills-japanese-tab" data-bs-toggle="pill" data-bs-target="#pills-japanese" type="button" role="tab" aria-controls="pills-japanese" aria-selected="false" onClick={() => handleTabClick("JP")} >Japanese</button>
                            </li>
                        }
                    </ul>

                    {
                        activeTab === "EN" ?
                            <ResumeForm initialValues={initialValues} validationSchema={validationSchema} handleSubmit={handleSubmit} role={role} handleBack={handleBack} />
                            :
                            <JapaneseResumeForm initialValues={initialValues} validationSchema={validationSchemaJp} handleSubmit={handleSubmit} role={role} handleBack={handleBack} />
                    }
                </div>
            </div>
        </>
    )
}
